import { BestPracticeDocumentTemplateViewModel } from "./BestPracticeDocumentTemplates.types";
import { useState } from "react";
import { useDotLegalQueryWithKey } from "@common/hooks/dotLegalReactQuery";
import { useTranslation } from "../localization/useTranslation";
import { useUrlProvider } from "../useUrlProvider";
import { DotLegalBreadCrumbModel } from "@dotlegal/dotlegal-ui-components";
import { isNullOrWhitespace } from "@common/stringOperations.ts";
import { EntityType } from "@common/Common.types.ts";
import { getSettings } from "@common/settingsProvider.ts";
import { downloadFile } from "@common/api/downloadFile.ts";

export function useBestPracticeDocumentTemplates() {
    const { translateString } = useTranslation();
    const { getMasterDataUrl } = useUrlProvider();

    const [showAddDialog, setShowAddDialog] = useState(false);
    const [selectedTemplate, setSelectedTemplate] = useState<BestPracticeDocumentTemplateViewModel | undefined>(undefined);
    const [showEditDialog, setShowEditDialog] = useState(false);
    const [showDeleteDialog, setShowDeleteDialog] = useState<BestPracticeDocumentTemplateViewModel | undefined>(undefined);
    const [downloadingDocument, setDownloadingDocument] = useState("");

    const { isLoading, data, refetch } = useDotLegalQueryWithKey<Array<BestPracticeDocumentTemplateViewModel>>(
        "best-practice-document-templates",
        "/best-practice-document-templates"
    );

    const breadCrumbs: Array<DotLegalBreadCrumbModel> = [
        { name: translateString("masterData"), link: getMasterDataUrl() },
        { name: translateString("bestPracticeDocumentTemplates") },
    ];

    const onTemplateSaved = () => {
        setSelectedTemplate(undefined);
        setShowAddDialog(false);
        setShowEditDialog(false);
        refetch();
    };

    const onTemplateDeleted = () => {
        setShowDeleteDialog(undefined);
        refetch();
    };

    const getBestPracticeDocumentBlobDocumentTemplateUrl = (model: BestPracticeDocumentTemplateViewModel) => {
        return `${getSettings().apiBaseUrl}/best-practice-document-templates/${model.id}/download`;
    };

    const onDownloadClick = async (model: BestPracticeDocumentTemplateViewModel) => {
        setDownloadingDocument(model.id);
        let url = getBestPracticeDocumentBlobDocumentTemplateUrl(model);
        await downloadFile(url, model.fileName).then((x) => {});
        setDownloadingDocument("");
    };

    return {
        breadCrumbs,
        isLoading,
        data,
        showAddDialog,
        setShowAddDialog,
        selectedTemplate,
        setSelectedTemplate,
        showEditDialog,
        setShowEditDialog,
        showDeleteDialog,
        setShowDeleteDialog,
        onTemplateSaved,
        onTemplateDeleted,
        downloadingDocument,
        onDownloadClick,
        getBestPracticeDocumentBlobDocumentTemplateUrl,
    };
}
